module.exports = __webpack_public_path__ + "img/iconinfo.aeb7178a.png";